<template>
  <div>
    <div class="container" style="margin-top: 25px;">
      <div class="xz-col abt">
        <el-tabs v-model="activeName">
          <el-tab-pane label="教学改革" name="first">
                <div class="newsList">
                  <div class="focusnews">
                    <div class="pictxtlist">
                      <div class="list ellipsis show" style="display: block;" v-if="Groups[0]&&Groups[0].articles&&Groups[0].articles.length>0" >
                        <div class="pictxt ellipsis clear">
                          <router-link :to="`/news/info/${Groups[0].articles[0].plateid}/${Groups[0].articles[0]._id}`"
                            :title="Groups[0].articles[0].title">
                            <div class="pic" :style="`background-image: url(${global.remoteIp}/uploads/${Groups[0].articles[0].picsrc})`">
                            </div>
                          </router-link>
                          <div class="title"><router-link :to="`/news/info/${Groups[0].articles[0].plateid}/${Groups[0].articles[0]._id}`"
                              :title="Groups[0].articles[0].title"
                              :style="`color:${Groups[0].articles[0].color?Groups[0].articles[0].color:'#000000'}; font-weight:${Groups[0].articles[0].weight?'bold':'500'}`">{{Groups[0].articles[0].title}}</router-link>
                          </div>
                          <div class="txt">
                            {{Groups[0].articles[0].description}}
                          </div>
                        </div>
                          <div style="display: inline-block;width: 465px;padding: 20px;padding-top: 5px;padding-right: 5px;    position: absolute;">
                          <div class="li title" v-for="(article , index) in  Groups[0].articles.slice(1)" :key="index"><span class="addtime">{{article.addtime.slice(0,10)}}</span><router-link
                            :to="`/news/info/${article.plateid}/${article._id}`"
                              :title="article.title"
                              :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`" >{{article.title}}</router-link>
                          </div>
                          </div>
                      </div>
                      <div class="list ellipsis show" style="display: none;" v-if="Groups[1]&&Groups[1].articles&&Groups[1].articles.length>0" >
                        <div class="pictxt ellipsis clear">
                          <router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                            :title="Groups[1].articles[0].title">
                            <div class="pic" :style="`background-image: url(${global.remoteIp}/uploads/${Groups[1].articles[0].picsrc})`">
                            </div>
                          </router-link>
                          <div class="title"><router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                              :title="Groups[1].articles[0].title"
                              :style="`color:${Groups[1].articles[0].color?Groups[1].articles[0].color:'#000000'}; font-weight:${Groups[1].articles[0].weight?'bold':'500'}`">{{Groups[1].articles[0].title}}</router-link>
                          </div>
                          <div class="txt">
                            {{Groups[1].articles[0].description}}
                          </div>
                        </div>
                        <div style="display: inline-block;width: 465px;padding: 20px;padding-top: 5px;padding-right: 5px;    position: absolute;">
                          <div class="li title" v-for="(article , index) in  Groups[1].articles.slice(1)" :key="index"><span class="addtime">{{article.addtime.slice(0,10)}}</span><router-link
                            :to="`/news/info/${article.plateid}/${article._id}`"
                              :title="article.title"
                              :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`" >{{article.title}}</router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </el-tab-pane>
          <el-tab-pane label="教学播报" name="second">
                <div class="newsList">
                  <div class="focusnews">
                    <div class="pictxtlist">
                      <div class="list ellipsis show" style="display: block;" v-if="Groups[1]&&Groups[1].articles&&Groups[1].articles.length>0" >
                        <div class="pictxt ellipsis clear">
                          <router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                            :title="Groups[1].articles[0].title">
                            <div class="pic" :style="`background-image: url(${global.remoteIp}/uploads/${Groups[1].articles[0].picsrc})`">
                            </div>
                          </router-link>
                          <div class="title"><router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                              :title="Groups[1].articles[0].title"
                              :style="`color:${Groups[1].articles[0].color?Groups[1].articles[0].color:'#000000'}; font-weight:${Groups[1].articles[0].weight?'bold':'500'}`">{{Groups[1].articles[0].title}}</router-link>
                          </div>
                          <div class="txt">
                            {{Groups[1].articles[0].description}}
                          </div>
                        </div>
                          <div style="display: inline-block;width: 465px;padding: 20px;padding-top: 5px;padding-right: 5px;    position: absolute;">
                          <div class="li title" v-for="(article , index) in  Groups[1].articles.slice(1)" :key="index"><span class="addtime">{{article.addtime.slice(0,10)}}</span><router-link
                            :to="`/news/info/${article.plateid}/${article._id}`"
                              :title="article.title"
                              :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`" >{{article.title}}</router-link>
                          </div>
                          </div>
                      </div>
                      <div class="list ellipsis show" style="display: none;" v-if="Groups[1]&&Groups[1].articles&&Groups[1].articles.length>0" >
                        <div class="pictxt ellipsis clear">
                          <router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                            :title="Groups[1].articles[0].title">
                            <div class="pic" :style="`background-image: url(${global.remoteIp}/uploads/${Groups[1].articles[0].picsrc})`">
                            </div>
                          </router-link>
                          <div class="title"><router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                              :title="Groups[1].articles[0].title"
                              :style="`color:${Groups[1].articles[0].color?Groups[1].articles[0].color:'#000000'}; font-weight:${Groups[1].articles[0].weight?'bold':'500'}`">{{Groups[1].articles[0].title}}</router-link>
                          </div>
                          <div class="txt">
                            {{Groups[1].articles[0].description}}
                          </div>
                        </div>
                        <div style="display: inline-block;width: 465px;padding: 20px;padding-top: 5px;padding-right: 5px;    position: absolute;">
                          <div class="li title" v-for="(article , index) in  Groups[1].articles.slice(1)" :key="index"><span class="addtime">{{article.addtime.slice(0,10)}}</span><router-link
                            :to="`/news/info/${article.plateid}/${article._id}`"
                              :title="article.title"
                              :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`" >{{article.title}}</router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      
      <div class="xz-col jlhd">
        <el-tabs value="third" v-if="Groups[2].articles&&Groups[2].articles.length>0">
          <el-tab-pane label="通知公告" name="third">
            <div  class="liselected" v-for="(article , index) in  Groups[2].articles.slice(0,3)" :key="index">
              <div style="display: inline-block;">
                <img :src="`${global.remoteIp}/uploads/${article.picsrc}`" style=" width: 157px;height: 93px;">
              </div>
              <div style="    display: inline-block;width: 175px;position: absolute;">
                <div class="title"><router-link :to="`/news/info/${article.plateid}/${article._id}`"
                    :title="article.title" :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`">{{article.title}}</router-link></div>
                  
                    <p class="artdesp">{{article.description}}</p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
       Groups: [
        {
          name: "教学改革", 
        },
        {
          name: "教学播报", 
        },
        {
          name: "通知公告", 
        }
      ],
       activeName: 'first',
    };
  },
  created() {
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=9`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
          break;
        }
      }
    }
  },
  mounted() {
    let watchflag = 0;
    
  },
   methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
    getMonthDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}-${now.getDate()}`;
    },
    getYearMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}-${now.getMonth() + 1}`;
    },
    getYear(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}`;
    },
  },
};
</script>
<style scoped>

.ellipsis .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.focusnews .pictxtlist .list .li a::before{
  content: "";
  width: 8px;
height: 8px;
background: #BFBFBF;
border-radius: 4px;
display: inline-block;
left: -18px;
    position: relative;
    line-height: 24px;
}
.focusnews .pictxtlist .pictxt{
      height: 337px;;
}

/deep/ .el-tabs__item.is-active{
      color: #CF2C24;
}
/deep/ .el-tabs__item{
  height: 50px; 
  line-height: 50px;
  font-size: 22px;
}
/deep/ .el-tabs__active-bar{
  background-color: #CF2C24;
}
.liselected{
  width: 374px;
    height: 93px;
    background: #FAFAFA;
    margin-top: 21px;
}
.liselected .title{
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    margin-left: 11px;
    padding-top: 19px;
    width: 191px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}
.artdesp{
    width: 175px;
    height: 34px;
    font-size: 13px;
    color: #666666;
    margin-top: 9px;
    margin-left: 12px;
    /* white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 18px;
}
</style>
